import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { DatePicker } from "antd";
import CommonTagsInput from "../../core/common/Taginput";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import JoditEditor from "jodit-react";
import dayjs, { Dayjs } from "dayjs";
import CommonTagsInputWithSuggestions from "../../core/common/Taginput/index copy";
import useApi from "../../core/customhook/useApi";
import Swal from "sweetalert2";

interface Employee {
  employee_id: string;
  employee_name: string;
  department: string;
}

const Task = () => {

  const [modalTags, setModalTags] = useState<string[]>([]);
  const [modalMembers, setModalMembers] = useState<string[]>([]);
  const [isDuration, setIsDuration] = useState(false);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [teamMembers, setTeamMembers] = useState<Employee[]>([]);
  const [proName, setProName] = useState("");
  const [attachments, setAttachments] = useState<File[]>([]);
  const [projectData, setProjectData] = useState([])
  const [teamMemberData, setTeamMemberData] = useState([])
  const [task, setTask] = useState([])
  const [count, setCount] = useState(1)

  const config = useMemo(
    () => ({
      readonly: false,
    }),
    []
  );

  const handleChangeStatus = () => {
    setIsDuration(!isDuration);
  };
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const {
    data: projectResponse,
    loading: projectDataLoading,
    error: projectDataError,
  } = useApi("/api/get-project", {
    method: "GET",
    autoCall: true,
  });



  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });


  const {
    data: taskData,
    loading: taskLoading,
    error: taskError,
  } = useApi("/api/get-all-project-task", {
    method: "GET",
    autoCall: true,
    dependencies: [count]
  });

  useEffect(() => {
    if (projectResponse?.success) {
      setProjectData(projectResponse?.projects)
    }
  }, [projectResponse])


  useEffect(() => {
    if (teamData?.success) {
      setTeamMemberData(teamData?.data)
    }
  }, [teamData])

  useEffect(() => {
    if (taskData?.success) {
      setTask(taskData?.data)
    }
  }, [taskData])


  const {
    data: taskDelete,
    loading: taskDeleteLoading,
    error: taskDeleteError,
    callApi: DELETETASK
  } = useApi("/api/delete-project-task", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteTaskRecord = async (taskId: any) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the task.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await DELETETASK(undefined, `/api/delete-project-task/${taskId}`);
        if (response.success) {
          Swal.fire({
            title: "Deleted!",
            text: "The task has been deleted.",
            icon: "success",
            showConfirmButton: true,
          });
          setCount(count + 1)
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while deleting the task.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const columns = [
    {
      title: "Task",
      dataIndex: "task_name",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          {record.task_name}
        </h6>
      ),
      sorter: (a: any, b: any) => a.task_name.localeCompare(b.task_name),
    },
    {
      title: "Project Name",
      dataIndex: "ProjectName",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">
          {record.project_name}
        </h6>
      ),
      sorter: (a: any, b: any) => a.project_name.localeCompare(b.project_name),
    },
    {
      title: "Owner",
      dataIndex: "owner_name",
      sorter: (a: any, b: any) => a.owner_name.localeCompare(b.owner_name),
    },
    {
      title: "StartDate",
      dataIndex: "start_date",
      sorter: (a: any, b: any) => a.start_date.localeCompare(b.start_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "EndDate",
      dataIndex: "end_date",
      sorter: (a: any, b: any) => a.end_date.localeCompare(b.end_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      render: (text: string) => (
        <div className="d-flex align-items-center">
          <span
            className={`rounded-circle d-flex justify-content-center align-items-center me-2 ${text === "High"
              ? "bg-transparent-danger"
              : text === "Low"
                ? "bg-transparent-success"
                : "bg-transparent-warning"
              }`}
            style={{ width: 10, height: 10 }}
          >
            <i
              className={`ti ti-point-filled ${text === "High"
                ? "text-danger"
                : text === "Low"
                  ? "text-success"
                  : "text-warning"
                }`}
            />
          </span>
          <span>{text}</span>
        </div>
      ),
      sorter: (a: any, b: any) => a.priority.localeCompare(b.priority),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        const statusColorMap: Record<string, { bg: string; text: string }> = {
          "Pending": { bg: "bg-transparent-warning", text: "text-warning" },
          "Ongoing": { bg: "bg-transparent-primary", text: "text-primary" },
          "Complete": { bg: "bg-transparent-success", text: "text-success" },
        };

        const { bg, text: textColor } = statusColorMap[text] || {
          bg: "bg-transparent-secondary",
          text: "text-secondary",
        };

        return (
          <div className="d-flex align-items-center">
            <span
              className={`rounded-circle d-flex justify-content-center align-items-center me-2 ${bg}`}
              style={{ width: 10, height: 10 }}
            >
              <i className={`ti ti-point-filled ${textColor}`} />
            </span>
            <span>{text}</span>
          </div>
        );
      },
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    // {
    //   title: "Complete",
    //   dataIndex: "complete", // must match the backend response key
    //   render: (value: number, record: any) => (
    //     <div className="dropdown">
    //       <Link
    //         to="#"
    //         className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
    //         data-bs-toggle="dropdown"
    //       >
    //         <span className="me-2">{value}%</span>
    //       </Link>
    //       <ul
    //         className="dropdown-menu dropdown-menu-end p-2"
    //         style={{
    //           maxHeight: "200px",
    //           overflowY: "auto",
    //           scrollbarWidth: "none",
    //           msOverflowStyle: "none",
    //         }}
    //       >
    //         {[...Array(11)].map((_, i) => {
    //           const percent = i * 10;
    //           return (
    //             <li key={percent}>
    //               <Link
    //                 to="#"
    //                 className={`dropdown-item ${percent === value ? "active" : ""}`}
    //                 onClick={() => {
    //                   console.log("Selected Completion %:", percent);
    //                   console.log("Record:", record);

    //                   // TODO: Replace with API call to update the `complete` value
    //                   // e.g., updateComplete(record.task_id, percent)
    //                 }}
    //               >
    //                 {percent}%
    //               </Link>
    //             </li>
    //           );
    //         })}
    //       </ul>
    //     </div>
    //   ),
    //   sorter: (a: any, b: any) => a.complete - b.complete,
    // },
    {
      title: "Complete",
      dataIndex: "complete",
      render: (value: number) => (
        <span>{value}%</span>
      ),
      sorter: (a: any, b: any) => a.complete - b.complete,
    },
    {
      title: "Tags",
      dataIndex: "tags",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-secondary"
          data-bs-toggle="modal"
          data-bs-target="#tagsModal"
          onClick={() => setModalTags(record.tags)}
        >
          View
        </button>
      ),
    },
    {
      title: "Team",
      dataIndex: "team_members",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-primary"
          data-bs-toggle="modal"
          data-bs-target="#membersModal"
          onClick={() => setModalMembers(record.team_members)}
        >
          View
        </button>
      ),
    },
    {
      title: "Logs",
      dataIndex: "",
      render: (_: any, record: any) => (
        <Link
          className="btn btn-sm btn-outline-primary"
          to={`/employee-time-logs/${record.task_id}`}
        >
          View
        </Link>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to={`/tasks/edit-task/${record.task_id}`}
            className="me-2"
          // data-bs-toggle="modal"
          // data-inert={true}
          // data-bs-target="#edit_task"
          // onClick={() => {
          //   setData({
          //     project_name: record.project_name,
          //     project_id: record.project_id,
          //     task_name: record.task_name,
          //     duration: record.duration,
          //     work_hour: record.work_hour,
          //     billing_type: record.billing_type,
          //     priority: record.priority,
          //     task_id: record.task_id,
          //     complete: record.complete || 0,
          //     status: record.status || "Pending"
          //   })
          //   setContent(record.description)
          //   setTeamMembers(record.team_members)
          //   setTags(record.tags)
          //   setStartDate(record.start_date ? dayjs(record.start_date) : null);
          //   setEndDate(record.end_date ? dayjs(record.end_date) : null);
          // }}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            onClick={() => {
              deleteTaskRecord(record.task_id)
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  const statusChoose = [
    { value: "None", label: "None" },
    { value: "Billable", label: "Billable" },
    { value: "Non Billable", label: "Non Billable" },
  ];
  const priorityChoose = [
    { value: "Select Priority", label: "Select Priority" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Low", label: "Low" },
  ];
  const [tags, setTags] = useState<string[]>([]);

  const [data, setData] = useState({
    task_id: "",
    project_id: "",
    project_name: "",
    task_name: "",
    duration: "",
    work_hour: "",
    billing_type: "",
    priority: "",
    complete: 0,
    status: "Pending"
  });

  const getInputData = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      setAttachments((prev) => [...prev, ...selectedFiles]);
    }
  };

  const removeFile = (index: number) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const {
    data: addprojectTaskResponse,
    loading: addprojectTaskDataLoading,
    error: addprojectTaskDataError,
    callApi: addProjectTask,
  } = useApi("/api/add-project-task", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("project_id", data.project_name);
    formData.append("task_name", data.task_name);
    formData.append("priority", data.priority);
    formData.append("billing_type", data.billing_type || "");
    formData.append("work_hour", data.work_hour || "");
    if (data.duration) formData.append("duration", data.duration);

    if (startDate) {
      formData.append("start_date", startDate.format("YYYY-MM-DD"));
    }

    if (endDate) {
      formData.append("due_date", endDate.format("YYYY-MM-DD"));
    }

    formData.append("description", content);
    tags.forEach((tag) => {
      formData.append("tags[]", tag);
    });
    teamMembers.forEach((member) => {
      formData.append("team_members[]", member.employee_id);
    });
    attachments.forEach((file) => {
      formData.append("file_path", file);
    });

    try {
      const respose = await addProjectTask(formData);
      if (respose.success) {
        Swal.fire({
          title: "Success!",
          text: "Project task added successfully.",
          icon: "success",
          confirmButtonText: "OK"
        });
        // ✅ Reset all form states
        setData({
          task_id: "",
          project_id: "",
          project_name: "",
          task_name: "",
          duration: "",
          work_hour: "",
          billing_type: "",
          priority: "",
          complete: 0,
          status: "Pending"
        });
        setStartDate(null); // If you're using dayjs/moment or a Date object
        setEndDate(null);
        setContent(""); // Reset description/editor content
        setTags([]);
        setTeamMembers([]);
        setAttachments([]);
        document.getElementById("close_modal")?.click()
        setCount(count + 1)
      }
    } catch (error) {
      console.log(error);
    }
  };
  const { callApi: editProjectTask } = useApi("/api/update-project-task", {
    method: "POST",
    autoCall: false,
  });


  const editProjectTaskData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("task_id", data.task_id);
    formData.append("project_id", data.project_id);
    formData.append("task_name", data.task_name);
    formData.append("priority", data.priority);
    formData.append("billing_type", data.billing_type || "");
    formData.append("work_hour", data.work_hour || "");
    formData.append("complete", data.complete.toString())
    formData.append("status", data.status || "Pending");

    if (data.duration) {
      formData.append("duration", data.duration);
    }

    if (startDate) {
      formData.append("start_date", startDate.format("YYYY-MM-DD"));
    }

    if (endDate) {
      formData.append("due_date", endDate.format("YYYY-MM-DD"));
    }

    formData.append("description", content);

    tags.forEach((tag) => {
      formData.append("tags[]", tag);
    });

    teamMembers.forEach((member) => {
      formData.append("team_members[]", member.employee_id);
    });

    attachments.forEach((file) => {
      formData.append("file_path", file);
    });

    try {
      const response = await editProjectTask(formData);
      if (response.success) {
        Swal.fire({
          title: "Updated!",
          text: "Project task updated successfully.",
          icon: "success",
          confirmButtonText: "OK"
        });
        document.getElementById("close_modal_edit")?.click();
        setCount(count + 1);
      }
    } catch (error) {
      console.error("Edit failed:", error);
    }
  };



  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Tasks</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active">Tasks</li>
                </ol>
              </nav>
            </div>
            <div className="my-xl-auto right-content d-flex">
              <div className="mb-2">
                <Link
                  // to={"#"}
                  to={"/tasks/add-task"}
                  // data-bs-toggle="modal"
                  // data-bs-target="#add_task"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Task
                </Link>
              </div>
              <div className="head-icons ms-2 mb-0">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Task List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Select Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="card-body p-0">
              <Table dataSource={task} columns={columns} Selection={false} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Task */}
      <div className="modal fade" id="add_task">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Task</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                id="close_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={postData}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Project Name<sup className="text-danger">*</sup>
                      </label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="text"
                          name="projectName"
                          className="form-control me-2"
                          placeholder="Project Name"
                          style={{ width: "100%" }}
                          value={proName}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const value = e.target.value;
                            setData({ ...data, project_name: value });
                            if (value.trim()) {
                              const matches = projectData.filter((item: any) =>
                                item.project_name
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              setFilteredSuggestions(matches);
                              setShowSuggestions(true);
                            } else {
                              setFilteredSuggestions([]);
                              setShowSuggestions(false);
                            }
                          }}
                        />
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <div
                            className="dropdown-menu show"
                            style={{
                              width: "100%",
                              maxHeight: "350px",
                              overflowY: "auto",
                              position: "absolute",
                              zIndex: 1000,
                            }}
                          >
                            <table className="table table-bordered table-hover mb-0">
                              <thead className="table-light sticky-top">
                                <tr>
                                  <th>Project Name</th>
                                  <th>Cost Center Code</th>
                                  <th>Department</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredSuggestions.map((item, index) => (
                                  <tr
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setData({
                                        ...data,
                                        project_name: item.project_id,
                                      });
                                      setProName(item.project_name);
                                      setShowSuggestions(false);
                                    }}
                                  >
                                    <td>{item.project_name}</td>
                                    <td>{item.cost_center_code}</td>
                                    <td>{item.department_name}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Task Name<sup className="text-danger">*</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Task Name"
                        name="task_name"
                        onChange={getInputData}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label me-2">
                        Team Members<sup className="text-danger">*</sup>
                      </label>
                      <CommonTagsInputWithSuggestions
                        value={teamMembers}
                        onChange={setTeamMembers}
                        placeholder="Team Members"
                        suggestions={teamMemberData}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date<sup className="text-danger">*</sup>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          value={startDate}
                          onChange={(date) => setStartDate(date)}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          disabledDate={(current) => {
                            // Disable dates before today's date
                            return current &&
                              current.isBefore(dayjs().startOf("day"))
                              ? true
                              : false;
                          }}
                        />

                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <label className="form-label">
                          {isDuration ? "Duration" : "Due Date"}
                        </label>
                        <label
                          className="text-pending"
                          onClick={handleChangeStatus}
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {isDuration ? "Enter End Date" : "Enter Duration"}
                        </label>
                      </div>
                      <div className="input-icon-end position-relative">
                        {isDuration ? (
                          <>
                            <div className="d-flex">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Duration"
                                name="duration"
                                onChange={getInputData}
                              />
                              <select
                                className="form-control ms-2"
                                style={{ maxWidth: "100px" }}
                              >
                                <option>days</option>
                                <option>hrs</option>
                              </select>
                            </div>
                          </>
                        ) : (
                          <>
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{ format: "DD-MM-YYYY", type: "mask" }}
                              value={endDate}
                              onChange={(date) => setEndDate(date)}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              disabledDate={(current) => {
                                // Disable dates before today's date or before the start date
                                return current &&
                                  (current.isBefore(dayjs().startOf("day")) ||
                                    (startDate && current.isBefore(startDate)))
                                  ? true
                                  : false;
                              }}
                            />

                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Work Hours<sup className="text-danger">*</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Work Hours"
                        name="work_hour"
                        onChange={getInputData}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Tag<sup className="text-danger">*</sup>
                      </label>
                      <CommonTagsInput
                        value={tags}
                        onChange={setTags}
                        placeholder="Add new"
                        className="custom-input-class"
                      />
                      <label className="form-label me-2">
                        <sub className="text-danger">
                          (Press enter to add more)
                        </sub>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Billing Type<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-control"
                        name="billing_type"
                        onChange={getInputData}
                      >
                        {statusChoose.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Priority<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-control"
                        name="priority"
                        onChange={getInputData}
                      >
                        {priorityChoose.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Description<sup className="text-danger">*</sup>
                      </label>
                      <JoditEditor
                        ref={editor}
                        value={content}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => { }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Upload Attachment</label>
                    <div className="bg-light rounded p-2">
                      <div className="profile-uploader border-bottom mb-2 pb-2">
                        <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                          Select File
                          <input
                            type="file"
                            className="form-control image-sign"
                            multiple
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>

                      {attachments.map((file, index) => (
                        <div
                          key={index}
                          className={`d-flex align-items-center justify-content-between ${index !== attachments.length - 1
                            ? "border-bottom mb-2 pb-2"
                            : ""
                            }`}
                        >
                          <div className="d-flex align-items-center">
                            <h6 className="fs-12 fw-medium me-1">
                              {file.name}
                            </h6>
                            <span className="badge badge-soft-info">
                              {(file.size / (1024 * 1024)).toFixed(2)} MB
                            </span>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-icon"
                            onClick={() => removeFile(index)}
                          >
                            <i className="ti ti-trash" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Task
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Task */}

      {/* Edit Task */}
      <div className="modal fade" id="edit_task">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Task</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                id="close_modal_edit"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={editProjectTaskData}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Project Name<sup className="text-danger">*</sup>
                      </label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="text"
                          name="projectName"
                          className="form-control me-2"
                          placeholder="Project Name"
                          style={{ width: "100%" }}
                          value={data.project_name}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const value = e.target.value;
                            setData({ ...data, project_name: value });
                            if (value.trim()) {
                              const matches = projectData.filter((item: any) =>
                                item.project_name
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              setFilteredSuggestions(matches);
                              setShowSuggestions(true);
                            } else {
                              setFilteredSuggestions([]);
                              setShowSuggestions(false);
                            }
                          }}
                        />
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <div
                            className="dropdown-menu show"
                            style={{
                              width: "100%",
                              maxHeight: "350px",
                              overflowY: "auto",
                              position: "absolute",
                              zIndex: 1000,
                            }}
                          >
                            <table className="table table-bordered table-hover mb-0">
                              <thead className="table-light sticky-top">
                                <tr>
                                  <th>Project Name</th>
                                  <th>Cost Center Code</th>
                                  <th>Department</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredSuggestions.map((item, index) => (
                                  <tr
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setData({
                                        ...data,
                                        project_name: item.project_name,
                                      });
                                      setShowSuggestions(false);
                                    }}
                                  >
                                    <td>{item.project_name}</td>
                                    <td>{item.cost_center_code}</td>
                                    <td>{item.department_name}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Task Name<sup className="text-danger">*</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Task Name"
                        name="task_name"
                        onChange={getInputData}
                        value={data.task_name}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label me-2">
                        Team Members<sup className="text-danger">*</sup>
                      </label>
                      <CommonTagsInputWithSuggestions
                        value={teamMembers}
                        onChange={setTeamMembers}
                        placeholder="Team Members"
                        suggestions={teamMemberData}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date<sup className="text-danger">*</sup>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          value={startDate}
                          onChange={(date) => setStartDate(date)}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          disabledDate={(current) => {
                            // Disable dates before today's date
                            return current &&
                              current.isBefore(dayjs().startOf("day"))
                              ? true
                              : false;
                          }}
                        />

                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <label className="form-label">
                          {isDuration ? "Duration" : "Due Date"}
                        </label>
                        <label
                          className="text-pending"
                          onClick={handleChangeStatus}
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {isDuration ? "Enter End Date" : "Enter Duration"}
                        </label>
                      </div>
                      <div className="input-icon-end position-relative">
                        {isDuration ? (
                          <>
                            <div className="d-flex">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Duration"
                                name="duration"
                                onChange={getInputData}
                                value={data.duration}
                              />
                              <select
                                className="form-control ms-2"
                                style={{ maxWidth: "100px" }}
                              >
                                <option>days</option>
                                <option>hrs</option>
                              </select>
                            </div>
                          </>
                        ) : (
                          <>
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{ format: "DD-MM-YYYY", type: "mask" }}
                              value={endDate}
                              onChange={(date) => setEndDate(date)}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              disabledDate={(current) => {
                                // Disable dates before today's date or before the start date
                                return current &&
                                  (current.isBefore(dayjs().startOf("day")) ||
                                    (startDate && current.isBefore(startDate)))
                                  ? true
                                  : false;
                              }}
                            />

                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Work Hours<sup className="text-danger">*</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Work Hours"
                        name="work_hour"
                        onChange={getInputData}
                        value={data.work_hour}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Tag<sup className="text-danger">*</sup>
                      </label>
                      <CommonTagsInput
                        value={tags}
                        onChange={setTags}
                        placeholder="Add new"
                        className="custom-input-class"
                      />
                      <label className="form-label me-2">
                        <sub className="text-danger">
                          (Press enter to add more)
                        </sub>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Billing Type<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-control"
                        name="billing_type"
                        onChange={getInputData}
                        value={data.billing_type}
                      >
                        {statusChoose.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Priority<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-control"
                        name="priority"
                        onChange={getInputData}
                        value={data.priority}
                      >
                        {priorityChoose.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Description<sup className="text-danger">*</sup>
                      </label>
                      <JoditEditor
                        ref={editor}
                        value={content}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => { }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Upload Attachment</label>
                    <div className="bg-light rounded p-2">
                      <div className="profile-uploader border-bottom mb-2 pb-2">
                        <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                          Select File
                          <input
                            type="file"
                            className="form-control image-sign"
                            multiple
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>

                      {attachments.map((file, index) => (
                        <div
                          key={index}
                          className={`d-flex align-items-center justify-content-between ${index !== attachments.length - 1
                            ? "border-bottom mb-2 pb-2"
                            : ""
                            }`}
                        >
                          <div className="d-flex align-items-center">
                            <h6 className="fs-12 fw-medium me-1">
                              {file.name}
                            </h6>
                            <span className="badge badge-soft-info">
                              {(file.size / (1024 * 1024)).toFixed(2)} MB
                            </span>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-icon"
                            onClick={() => removeFile(index)}
                          >
                            <i className="ti ti-trash" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Completion (%)<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-select"
                        name="complete"
                        value={data.complete}
                        onChange={(e) =>
                          setData({ ...data, complete: parseInt(e.target.value, 10) })
                        }
                      >
                        {[...Array(11)].map((_, i) => {
                          const value = i * 10;
                          return (
                            <option key={value} value={value}>
                              {value}%
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Status<sup className="text-danger">*</sup>
                      </label>
                      <select
                        className="form-select"
                        name="status"
                        onChange={(e) => setData({ ...data, status: e.target.value })}
                        value={data.status}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Ongoing">Ongoing</option>
                        <option value="Complete">Completed</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Edit Task
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Task */}


      {/* Todo Details */}
      <div className="modal fade" id="view_todo">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark">
              <h4 className="modal-title text-white">
                Respond to any pending messages
              </h4>
              <span className="badge badge-danger d-inline-flex align-items-center">
                <i className="ti ti-square me-1" />
                Urgent
              </span>
              <span>
                <i className="ti ti-star-filled text-warning" />
              </span>
              <Link to="#">
                <i className="ti ti-trash text-white" />
              </Link>
              <button
                type="button"
                className="btn-close custom-btn-close bg-transparent fs-16 text-white position-static"
                data-bs-dismiss="modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <h5 className="mb-2">Task Details</h5>
              <div className="border rounded mb-3 p-2">
                <div className="row row-gap-3">
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Created On</span>
                      <p className="text-dark">22 July 2025</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Due Date</span>
                      <p className="text-dark">22 July 2025</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Status</span>
                      <span className="badge badge-soft-success d-inline-flex align-items-center">
                        <i className="fas fa-circle fs-6 me-1" />
                        Completed
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="mb-2">Description</h5>
                <p>
                  Hiking is a long, vigorous walk, usually on trails or
                  footpaths in the countryside. Walking for pleasure developed
                  in Europe during the eighteenth century. Religious pilgrimages
                  have existed much longer but they involve walking long
                  distances for a spiritual purpose associated with specific
                  religions and also we achieve inner peace while we hike at a
                  local park.
                </p>
              </div>
              <div className="mb-3">
                <h5 className="mb-2">Tags</h5>
                <div className="d-flex align-items-center">
                  <span className="badge badge-danger me-2">Internal</span>
                  <span className="badge badge-success me-2">Projects</span>
                  <span className="badge badge-secondary">Reminder</span>
                </div>
              </div>
              <div>
                <h5 className="mb-2">Assignee</h5>
                <div className="avatar-list-stacked avatar-group-sm">
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-23.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-24.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-25.jpg"
                      alt="img"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Todo Details */}



      {/* Tags Modal */}
      <div className="modal fade" id="tagsModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Task Tags</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {modalTags.length > 0 ? (
                modalTags.map((tag, index) => (
                  <span key={index} className="badge bg-info me-1">
                    {tag}
                  </span>
                ))
              ) : (
                <p>No tags available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="membersModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Team Members</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {modalMembers.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Employee ID</th>
                        <th scope="col">Employee Name</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Department</th>
                        {/* <th scope="col">Time Logs</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {modalMembers.map((item: any, index: number) => (
                        <tr key={item.employee_id}>
                          <td>{index + 1}</td>
                          <td>{item.employee_id}</td>
                          <td>{item.employee_name}</td>
                          <td>{item.designation}</td>
                          <td>{item.department}</td>
                          {/* <td>view</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No team members assigned.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Task;
